import { ref, type Ref } from 'vue'
import { defineStore } from 'pinia'
import { getReferentials } from '@accor/customer-api/cloud'
import { i18nService } from '@accor/customer-vue-services'

export interface Civility {
  code: string
  value: string
  label: string
}

export interface Country {
  alpha2Code: string
  callingCodes: []
  geoCode: string
  idCardRequired: boolean
  name: string
  nationality: {
    geoCode: string
    isoCode: string
    name: string
  }
  states: []
}

export interface Referentials {
  civilities: Civility[]
  countries: Country[]
}

export const useReferentialsStore = defineStore('referentials', () => {
  const referentials: Ref<Referentials> = ref({
    civilities: [],
    countries: []
  })

  const isReferentialLoaded = ref(false)

  // Refresh only once
  const refreshReferentials = async () => {
    if (isReferentialLoaded.value) return
    const locale = i18nService.getCurrentLocale()
    const data = await getReferentials({ params: 'countries,civilities', lang: locale })
    Object.assign(referentials.value, data)
    isReferentialLoaded.value = true
  }

  return {
    referentials,
    refreshReferentials
  }
})
